import React from 'react';
import { useContext } from '../../Context';

export default function NoData() {
  const { state } = useContext();

  return (
    <div className="mt20">
      {state.categories == null
        ? 'Please, wait ...'
        : 'No matching records found'}
    </div>

  );
}
